import React, { useEffect } from "react";
import { NewTab, PageTab } from "../../../components";
import BusinessInformation from "./AddVendor/BusinessInformation";
import GeneralInformation from "./AddVendor/GeneralInformation";
import Accounts from "./AddVendor/Accounts";
import Contacts from "./AddVendor/Contacts";
import Confidential from "./AddVendor/Confidential";
import Comments from "./AddVendor/Comments";
import Documents from "./AddVendor/Documents";
import { useDispatch, useSelector } from "react-redux";
import { clearVendorProfile } from "../../../redux/slices/vendor/vendorSlice";
import { useLocation } from "react-router-dom";
import Placements from "./AddVendor/Placements";
import Invoicesandpayments from "./AddVendor/Invoicesandpayments";

const AddVendor = ({ isEditable = false, vendorId }) => {
  const location = useLocation();
  const editVendor = location.pathname;
  if (editVendor == "/vendor/add-vendor") {
    isEditable = true;
  }
  const vendorProfileUiid = useSelector(
    (state) => state.vendor.vendorProfileUiid
  );
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(clearVendorProfile());
    };
  }, []);
  const AddVendorsMenus = [
    {
      title: "Business Information",
      page: (
        <BusinessInformation
          isEditable={isEditable}
          editVendor={editVendor}
          vendorId={vendorId}
        />
      ),
      type: "main",
    },

    {
      title: "General Information",
      page: (
        <GeneralInformation
          isEditable={isEditable}
          editVendor={editVendor}
          vendorId={vendorId}
        />
      ),
      type: "main",
    },
    // {
    //   title: "Accounts",
    //   page: <Accounts />,
    //   type: "main",
    // },
    {
      title: "Contacts",
      page: (
        <Contacts
          isEditable={isEditable}
          editVendor={editVendor}
          vendorId={vendorId}
        />
      ),
      type: "main",
    },
    {
      title: "Confidential",
      page: (
        <Confidential
          isEditable={isEditable}
          editVendor={editVendor}
          vendorId={vendorId}
        />
      ),
      type: "main",
    },
    {
      title: "Comments",
      page: (
        <Comments
          isEditable={isEditable}
          editVendor={editVendor}
          vendorId={vendorId}
        />
      ),
      type: "main",
    },
    {
      title: "Documents",
      page: (
        <Documents
          isEditable={isEditable}
          editVendor={editVendor}
          vendorId={vendorId}
        />
      ),
      type: "main",
    },
    {
      title: "Placements",
      page: (
        <Placements
          isEditable={isEditable}
          editVendor={editVendor}
          vendorId={vendorId}
        />
      ),
      type: "main",
    },
    {
      title: "Invoices and payments",
      page: (
        <Invoicesandpayments
          isEditable={isEditable}
          editVendor={editVendor}
          vendorId={vendorId}
        />
      ),
      type: "main",
    },
    // {
    //   title: "Placements",
    //   page: (
    //     <Placements
    //       isEditable={isEditable}
    //       editVendor={editVendor}
    //       vendorId={vendorId}
    //     />
    //   ),
    //   type: "main",
    // },
  ];
  return (
    <>
      <NewTab
        tabs={AddVendorsMenus}
        color="black"
        //activeColor="primary"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="add-vendor"
      />
    </>
  );
};

export default AddVendor;
